export default {
    DEFAULT_LOCKED_COINS: ['USDT', 'BNB'],
    FIAT_LIST: ['EUR', 'USD', 'RUB', 'VND', 'TRY', 'THB', 'INR', 'PEN', 'MXN', 'CHF', 'COP', 'SEK', 'HUF', 'JPY', 'NGN', 'AED', 'CAD', 'AUD', 'UAH', 'PHP', 'RON', 'IDR', 'PLN', 'BGN', 'HKD', 'GBP', 'UGX', 'CZK', 'ZAR', 'DKK', 'NZD', 'KZT', 'TWD', 'HRK', 'VES', 'BRL', 'KES', 'ARS', 'CNY', 'GEL', 'UYU', 'CLP', 'GHS', 'LBP', 'SAR', 'MAD', 'EGP', 'AZN', 'BOB', 'LKR', 'PAB', 'PKR', 'PYG', 'ISK', 'QAR', 'BHD', 'OMR', 'DZD', 'TND', 'SDG', 'CRC', 'MNT', 'UZS', 'TJS', 'AMD', 'TZS', 'XOF', 'XAF', 'KGS'],
    ASSETS_FIXED_ZEROS_QUANTITY: {
        USD: 2,
        USDT: 2,
        USDC: 2,
        FDUSD: 2,
        XRP: 2,
        BNB: 6,
        ETH: 6,
        BTC: 8,
        ADA: 1,
        DOT: 2,
        SOL: 3,
        TUSD: 2
    },
    ADDITIONAL_ASSETS: ['USDT', 'BNB', 'BTC', 'ETH', 'XRP', 'TUSD', 'USDC', 'FDUSD'],
    ALL_AVAILABLE_SPOT_COINS: ['USDT', 'BNB', 'BTC', 'ETH', 'XRP', 'USDC', 'FDUSD', 'TUSD']
};
export const passwordAllowedSymbolsRegExp = /^[a-zA-Z0-9!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]+$/;
export const emailAllowedSymbolsRegExp = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const systemPromoCodes = ['Whitelist'];
